import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { CardStyleInterpolators } from "@react-navigation/stack";
import { Spacings, View } from "react-native-ui-lib";
import {
  Button,
  ModalCloseButton,
  Page,
  Text,
  TextButton,
} from "@towersystems/roam-common-native";
import { ReceiptModalRootParmList, SaleRootParamList } from "../../../../types";
import { createStackHeaderNavigator } from "@towersystems/roam-common-native";
import { useQuerySale } from "../../utils";
import { SaleContext } from "../../utils/sales/context";
import { EmailReceiptModalScreen } from "../EmailReceiptModalScreen/EmailReceiptModalScreen";
import { PrintReceiptModalScreen } from "../PrintReceiptModalScreen";
import { ReceiptOptionsModalScreen } from "../ReceiptOptionsModalScreen";
import { DownloadReceiptScreen } from "../DownloadReceiptScreen";
import { PickEmailReceiptTemplateModalScreen } from "../PickEmailReceiptTemplateModalScreen";
import { useTranslation } from "react-i18next";

export type ReceiptsModalRootScreenProps = NativeStackScreenProps<
  SaleRootParamList,
  "ReceiptsModalRootScreen"
> & {};

export const ReceiptsModalRootScreen = ({
  route,
  navigation,
}: ReceiptsModalRootScreenProps) => {
  const { t } = useTranslation("sales");
  const Stack = createStackHeaderNavigator<ReceiptModalRootParmList>();
  const saleId = route.params.saleId;
  const { item: sale } = useQuerySale({ saleId });

  if (!sale) {
    return (
      <Page>
        <View center>
          <Text center variant="heading2" fontWeight="bold">
            {t("common:error")}
          </Text>
          <Text center variant="body">
            {t("common:go_back_try_again")}
          </Text>
        </View>
        <View center style={{ marginTop: Spacings.s4 }}>
          <TextButton onPress={() => navigation.goBack()}>
            {t("common:go_back")}
          </TextButton>
        </View>
      </Page>
    );
  }

  return (
    <SaleContext.Provider value={{ sale }}>
      <Stack.Navigator>
        <Stack.Group>
          <Stack.Screen
            name="ReceiptOptionsModalScreen"
            options={{
              title: t("receipt_landing_title"),
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => <ModalCloseButton type="Close" />,
            }}
            component={ReceiptOptionsModalScreen}
          />
          <Stack.Screen
            name="EmailReceiptModalScreen"
            options={{
              title: t("email_receipt_title"),
              headerTitleAlign: "center",
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
            component={EmailReceiptModalScreen}
          />
          <Stack.Screen
            name="PrintReceiptModalScreen"
            options={{
              title: t("print_download_receipt_title"),
              headerTitleAlign: "center",
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
            component={PrintReceiptModalScreen}
          />

          <Stack.Screen
            name="DownloadReceiptScreen"
            options={{
              title: t("print_download_receipt_title"),
              headerTitleAlign: "center",
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
            component={DownloadReceiptScreen}
          />
          <Stack.Screen
            name="PickEmailReceiptTemplateModalScreen"
            options={{
              title: t("print_download_receipt_title"),
              headerTitleAlign: "center",
              animationEnabled: true,
              cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
              headerLeft: () => <ModalCloseButton type="Back" />,
            }}
            component={PickEmailReceiptTemplateModalScreen}
          />
        </Stack.Group>
      </Stack.Navigator>
    </SaleContext.Provider>
  );
};
